// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const StoreDetailClient = registerClientReference(
    function() { throw new Error("Attempted to call StoreDetailClient() from the server but StoreDetailClient is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/web/src/app/(buyer)/stores/[id]/store-detail-client.tsx",
    "StoreDetailClient",
);
